import UrlPattern from 'url-pattern';

import { LANGUAGE_DE, LANGUAGE_FR } from '@common/constants/languages';
import {
  frenchUrlsLinkGenerationRouteMap,
  germanUrlsLinkGenerationRouteMap,
} from '@common/routes.mjs';

const generateUrlPatterns = routesMap =>
  Object.entries(routesMap).reduce(
    (accum, [pathname, url]) => ({
      ...accum,
      [pathname]: new UrlPattern(
        typeof url === 'string' || typeof url.pattern === 'string'
          ? `${url.pattern ?? url}(/)(?)`
          : url.pattern,
      ),
    }),
    {},
  );

const germanUrlPatterns = generateUrlPatterns(germanUrlsLinkGenerationRouteMap);
const frenchUrlPatterns = generateUrlPatterns(frenchUrlsLinkGenerationRouteMap);

function getUrlPatternsByLanguage(language) {
  switch (language) {
    case LANGUAGE_FR:
      return frenchUrlPatterns;

    case LANGUAGE_DE:
    default:
      return germanUrlPatterns;
  }
}

export function findRouteByPath(path, lang) {
  const patterns = getUrlPatternsByLanguage(lang);
  const [pathname, pattern] =
    Object.entries(patterns).find(([, urlPattern]) => urlPattern.match(path)) ||
    [];

  return {
    pathname,
    pattern,
  };
}
